import styled from 'styled-components';

export const AfiLogo = styled.img.attrs(() => ({
  alt: 'AFi logo',
  title: 'AFi logo',
  src: 'assets/icon/logo.png',
}))`
  height: 60px;
`;
